import {isNil} from 'ramda';

import {DeliveryNoteItem} from '../types/DeliveryNoteDocumentPreviewFormDefinition';
import {hasItemPriceMismatch} from './hasItemPriceMismatch';
import {isInvalidDocumentItemNumber} from './isInvalidDocumentItemNumber';

export function checkForInvalidItems(
  items: DeliveryNoteItem[],
  allowZeroPrices = false,
  isPriceRecalculationEnabled = false
): boolean {
  const isInvalidPrice = (price: DeliveryNoteItem['unitPrice']) =>
    allowZeroPrices ? isInvalidDocumentItemNumber(price, true) : isNil(price) || price <= 0;

  return items.some((item: DeliveryNoteItem) => {
    if (!item.isActive) {
      return false;
    }

    const hasInvalidFields =
      !item.number || !item.name || !item.manufacturer || !item.unit || !item.vat;

    const hasInvalidNumericFields =
      isNil(item.quantity) ||
      item.quantity <= 0 ||
      isInvalidPrice(item.unitPrice) ||
      isInvalidPrice(item.totalPrice);

    return (
      hasInvalidFields ||
      hasInvalidNumericFields ||
      (isPriceRecalculationEnabled && hasItemPriceMismatch(item, allowZeroPrices))
    );
  });
}
